// extracted by mini-css-extract-plugin
module.exports = {"spasticCenteredTickedBulletList":"_3n-MQ","spasticCenteredTickedBulletList--item":"_4EzUB"};